import React from 'react'
import ToDoContainer from '../../../Components/Apps/ToDo'

export default function ToDo() {
  return (
    <div className='page-body'>
        <ToDoContainer/>
    </div>
  )
}
